module.exports = __webpack_public_path__ + "img/logo-white@3x.730cd7a7.png";